<template>
    <div class="container feedback template-bg-gray">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec">
                <div class="loop_container bg-transparent update-request-form-common">
                    <div class="card form-wrapper">
                        <div class="feedback_container feedback_newupdate">
                            <div class="community-logo" v-if="logoURL">
                                <img :src="logoURL" class="top-logo custom-logo" alt="Community Logo">
                            </div>
                            <div class='common-space-from-logo my-text-center' v-if="!isSubmitted">
                                <h1 id="main-header" class="template-title-feedback" aria-live="polite">{{ pageTitle }}</h1>
                            </div>
                            <div class='common-space-from-logo my-text-center' v-else>
                                <h1 id="main-header" class="template-title-feedback" aria-live="polite">Thank You!</h1>
                                <p class="custom-content my-text-center" aria-live="polite">We really appreciate your
                                    feedback!</p>
                            </div>
                            <form @submit.prevent="submitFeedback()" class="template-form" v-if="!isSubmitted">
                                <p class="required-note template-label" id="required-note">
                                    Fields marked with an asterisk (<span class="required-symbol">*</span>) are
                                    required.
                                </p>
                                <div class="row ">
                                    <div class="col-md-12 ">
                                        <div :class="[{ 'b-error': errors.has('comment') }, 'form-group', 'pd-remove', 'unsubscribe-height']"
                                            class="input-group pd-remove unsubscribe-height input-focus request-form-question-container template-input-text-area common-question-textarea-for-v1-v2">
                                            <textarea aria-label="Character count available for this textarea"
                                                id="textarea" class="form-control placeholder-bold" name="comment"
                                                rows="10" v-model="comment" required aria-required="true"
                                                v-bind:class="{ 'request-form-error-border': errors.has('description') }"
                                                @input="e => comment = sanitizeInput(e.target.value)"></textarea>
                                            <div class="form-group  pd-remove unsubscribe-btn mb-0-custom">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 text-right">
                                        <div class="form-group pd-remove unsubscribe-btn">
                                            <button type="submit" name="helpAction" v-bind:style="reviewBtn"
                                                class="btn btn_info template-review-submit template-button-width feedback-button">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <!--The following code works for providing feedback on the askAnalysis-->
                            <div v-show="isAskAnalysis" v-if="!isSubmitted" class="m-top-34">
                                <template>
                                    <div class="row my">
                                        <div class="col-md-12">
                                            <h2 class="text-center email-request-title">Our recommendation</h2>
                                        </div>
                                    </div>
                                    <div class="email-request-review">
                                        <div class="template-request-review">
                                            <p v-if="ask.analysis" class="font-color">{{
                                                ask.analysis.summary.summary_of_results }}</p>
                                        </div>
                                    </div>
                                    <div class="row my">
                                    <div class="col-md-12">
                                        <h3 class="text-center email-request-title">FYI, here's the request</h3>
                                    </div>
                                </div>
                                    <div class="email-request-review">
                                        <div class="template-request-review">
                                            <span id="feedback-name"
                                                v-if="ask.createdByMemberID && ask.createdByMemberID.first && ask.createdByMemberID.last">{{
                                                    ask.createdByMemberID.first + ' ' + ask.createdByMemberID.last }}</span>
                                            <br>
                                            <span id="feedback-email"
                                                v-if="ask.createdByMemberID && $lodash.has(ask.createdByMemberID.emails, 0)">{{
                                                    ask.createdByMemberID.emails[0] }}
                                            </span>
                                            <br><br>
                                            <span id="feedback-name">{{ ask.subject }}</span>
                                            <br>
                                            <p class="font-color">{{ ask.text }}</p>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <ul class="list-inline text-center footer-links">
                        <li>
                            <a :href="community.content.landingPageURL" target="_blank" class="links"
                                v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length"
                                tabindex="0">Learn More</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Learn More</a>
                        </li>
                        <li>
                            <a :href="community.content.termsConditionsURL" target="_blank" class="links"
                                v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length"
                                tabindex="0">Terms Of Use [pdf]</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use [pdf]</a>
                        </li>
                        <li>
                            <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank"
                                v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt
                                Out</a>
                            <a href="javascript:void(0)" v-else>Opt Out</a>
                        </li>
                    </ul>
                    <div class="unsubscribe-community-logo">
                        <a :href="(community.content && community.content.landingPageURL) || 'https://www.protopia.co'" target="_blank"><img v-if="community.content"
                                :src="footerLogoURL" :alt="'Community Logo of ' + community.content.parameter4"></a>
                        <span class="sr-only">Protopia - Visit our site</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from "../services/API";
import { sanitizeInput } from '../utils/sanitizer';
import { getFooterURL, getLogoURL } from "../helpers/getCustomSettings";

export default {
    name: 'FeedbackView',
    props: {
        context: {
            type: String,
            required: true
        },
        askId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            api: new API(),
            comment: '',
            ask: {},
            isSubmitted: false,
            community: {},
            logoURL: "",
            footerLogoURL: "",
            reviewBtn: {
                'background-color': '#9178A0',
                'color': '#ffffff'
            },
            rating: 0,
        };
    },
    computed: {
        formattedContext() {
            if (!this.context) return '';
            return this.context.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        },
        isAskAnalysis() {
            return this.context === 'ask-analysis';
        },
        pageTitle() {
            return this.isAskAnalysis ? 'Share your feedback on this recommendation' : 'Share Your Feedback';
        }
    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        const ratingParams = urlParams.get('rating');
        if (ratingParams) {
            this.rating = parseInt(ratingParams, 10);
        }
        this.loadData();
    },
    methods: {
        async loadData() {
            if (this.askId) {
                try {
                    const response = await this.api.get(`asks/${this.askId}`);
                    this.ask = response.data;
                    this.community = response.data.community;
                    const customSettings = this.community.customSettings;
                    this.logoURL = getLogoURL(customSettings);
                    this.footerLogoURL = getFooterURL(customSettings);
                    this.reviewBtn = {
                        'background-color': customSettings.primaryBtnBgColor || '#9178A0',
                        'color': customSettings.primaryTxtColor || '#ffffff'
                    };
                } catch (error) {
                    console.error("Failed to load ask data for branding:", error);
                    this.footerLogoURL = getFooterURL({});
                }
            } else {
                this.footerLogoURL = getFooterURL({});
            }
        },
        sanitizeInput(input) {
            return sanitizeInput(input);
        },
        async submitFeedback() {
            if (!this.comment.trim()) {
                alert('Please provide your feedback before submitting.');
                return;
            }

            if (this.isAskAnalysis) {

                const feedbackPayload = {
                    askId: this.askId,
                    comment: this.comment,
                    rating: this.rating
                };

                try {
                    await this.api.post(`asks/${this.askId}/analysis-feedback`, feedbackPayload);
                    this.isSubmitted = true;
                    document.title = 'Thank You';
                    window.scrollTo(0, 0);
                } catch (err) {
                    console.error("Failed to add feedback to the analysis ", err);
                }
                return;
            }
        },
        goBack() {
            this.$router.back();
        }
    }
};
</script>

<style scoped>
.btn-secondary {
    background-color: #6c757d;
    border-color: #6c757d;
    color: white;
}

.mr-2 {
    margin-right: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/FeedbackView.vue